<template>
  <div class="present-page">
    <Present v-if="loaded"
      :boxId="$route.params.boxId"
      :postcards="postcardResponseData"
    />
    <PresentPlaceholder v-else />

    <PresentSticky />

    <Explore />

    <Postcard
      v-if="loaded"
    />

    <Packaging v-if="loaded" />

    <Business v-if="loaded" />

    <Faq
      v-if="loaded && faq"
      :data="faq"
    />

    <Contact v-if="loaded" />

    <CreateYourOwn v-if="loaded" />
  </div>
</template>

<script>
/* eslint vue/no-unused-components: 0 */
import { logicMixin } from '@/mixins/LogicMixin';

import axios from 'axios';
import AOS from 'aos';
import 'aos/dist/aos.css';

import Present from '@/components/PresentPage/Present';
import PresentPlaceholder from '@/components/PresentPage/PresentPlaceholder';
import PresentSticky from '@/components/PresentPage/PresentSticky';
import Explore from '@/components/PresentPage/Explore';
import Postcard from '@/components/PresentPage/Postcard';
import Packaging from '@/components/PresentPage/Packaging';
import Business from '@/components/PresentPage/Business';
import Contact from '@/components/PresentPage/Contact';
import Faq from '@/components/PresentPage/Faq';
import CreateYourOwn from '@/components/PresentPage/CreateYourOwn';
import { TrackingMixin } from '@/mixins/TrackingMixin';

export default {
  name: 'PresentPage',
  mixins: [logicMixin, TrackingMixin],
  components: {
    Present,
    PresentPlaceholder,
    PresentSticky,
    Explore,
    Postcard,
    Packaging,
    Business,
    Contact,
    Faq,
    CreateYourOwn
  },
  data: function () {
    return {
      loaded: false,
      landingPageName: '',
      postcardSrc: 'https://componata.de/wp-content/uploads/2021/02/2802_Product-400x400.jpg',
      postcardId: null,
      postcardName: '',
      usedProductId: null,
      heroEpigraph: '',
      heroTitle: '',
      heroDescription: '',
      occassionPresentText: '',
      overviewTitle: '',
      overviewDescription: '',
      hasPackagingImg: false,
      postcardResponseData: null,
      faq: null
    };
  },
  mounted() {
    this.$store.commit('setCurrentLevel', 1);

    // UI
    AOS.init({
      once: true
    });

    window.addEventListener('load', AOS.refresh);

    // Logic
    if (this.$store.getters.getSelectedQty === undefined || this.$store.getters.getSelectedQty === '' || this.$store.getters.getSelectedQty === 0) {
      this.$store.commit('setSelectedQty', { qty: 1, store: this.$store });
    }
    axios
      .get(
        'https://componata.de/faq.json'
      )
      .then((response) => {
        this.faq = response.data.faq;
      });

    this.$root.$on('level1Loaded', this.init);
    if (this.$store.getters.getListItemsLevel1Unfiltered.length > 0) {
      this.init();
    }
  },
  destroyed () {
    window.removeEventListener('load', AOS.refresh);
  },
  beforeDestroy() {
    this.$root.$off('level1Loaded', this.init);
  },
  methods: {
    init: function() {
      if (this.$route.params.boxId) {
        const foundItem = this.$store.getters.getListItemsLevel1Unfiltered.filter(n => n.id === parseInt(this.$route.params.boxId))[0];
        if (foundItem) {
          this.setFoundItem(foundItem);
        } else {
          axios
            .get(
              process.env.VUE_APP_BASE_URL +
            '/wp-json/geschenkbox/v1/get_level_1_fast?selectedId=' + this.$route.params.boxId
            )
            .then((response) => {
              const validItems = this.extendLvl1Req(response.data);
              if (validItems.length > 0) {
                this.setFoundItem(validItems[0]);
              } else {
                this.$router.push(this.cLink('/404'));
              }
            });
        }
      }

      // this.criteoTracking({
      //   event: 'viewItem',
      //   item: this.$store.getters.getSelectedItem.data.id.toString(),
      // });
    },
    setFoundItem(item) {
      this.$store.commit('setSelectedItem', item);
      if (this.$route.name === 'CatalogPresentPageProductDetail') {
        this.$store.getters.getSelectedItem.data.products.forEach((product) => {
          if (product.product === this.$route.params.product) {
            this.$store.commit('setModalItem', product);
          }
        });
        this.$store.commit('setModalOpen', true);
      } else {
        this.$store.commit('setModalOpen', false);
      }
      this.loaded = true;
    }
  },
  watch: {
    $route(to, from) {
      if (to.name === 'CatalogPresentPageDeliveryModal') {
        this.$store.commit('setModalOpen', false);
      } else if (this.$route.name === 'CatalogPresentPageProductDetail') {
        this.$store.getters.getListItemsLevel3All.forEach((product) => {
          if (product.id === parseInt(this.$route.params.product)) {
            this.$store.commit('setModalItem', product);
          }
        });
        this.$store.commit('setModalOpen', true);
      } else {
        this.$store.commit('setModalOpen', false);
      }
    },
  },
  jsonld() {
    if (
      this.$store.getters.getSelectedItem.data === null ||
      this.$store.getters.getSelectedItem.data === undefined ||
      this.$store.getters.getSelectedItem.data.id === undefined
    ) {
      return {};
    }

    return {
      '@context': 'http://schema.org/',
      '@type': 'Product',
      sku: this.$store.getters.getSelectedItem.data.id.toString(),
      mpn: this.$store.getters.getSelectedItem.data.id.toString(),
      image: this.$store.getters.getSelectedItem.data.photos[this.$store.getters.groupAbb][0].hd,
      name: this.$store.getters.getSelectedItem.data.name,
      description: this.$store.getters.getSelectedItem.data.description,
      brand: {
        '@type': 'Thing',
        name: 'Componata',
      },
      audience: {
        '@type': 'PeopleAudience',
        suggestedGender: 'unisex',
      },
      offers: {
        '@type': 'Offer',
        priceCurrency: 'EUR',
        price: this.getPriceRawForGroup(this.$store.getters.getSelectedItem.data, this.$store.getters.getUserGroupId, false).toFixed(2),
        itemCondition: 'http://schema.org/NewCondition',
        availability: 'http://schema.org/InStock',
      },
    };
  },
  metaInfo () {
    if (this.$store.getters.getSelectedItem.data) {
      return {
        title: this.$store.getters.getSelectedItem.data.name
      };
    }
  }
};
</script>

<style lang="scss" scoped>
/**
 * PresentPage
 *
 * @author juanpablob <m.juanpablob@gmail.com>
 * @desc Present Page (Landing Page-style)
 * @since 2021-04-09
**/

$component: 'present-page';

.#{$component} {
  background-color: $white;

  /** RESPONSIVENESS **/

  // ——————————————————————————————
  // Max LG
  // ——————————————————————————————
  @media (max-width: map-get($landing-page, 'viewport-lg')) {
  }

  // ——————————————————————————————
  // Max MD
  // ——————————————————————————————
  @media (max-width: map-get($landing-page, 'viewport-md')) {
  }

  // ——————————————————————————————
  // Max SM
  // ——————————————————————————————
  @media (max-width: map-get($landing-page, 'viewport-sm')) {
  }

  // ——————————————————————————————
  // Max XS
  // ——————————————————————————————
  @media (max-width: map-get($landing-page, 'viewport-xs')) {

  }
}
</style>
